var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAiChatColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1234_17850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2637 2.01367C17.3407 1.7881 17.6593 1.7881 17.7363 2.01367L18.2861 3.62305C18.4612 4.13579 18.8642 4.53877 19.377 4.71387L20.9863 5.26367C21.2119 5.34073 21.2119 5.65927 20.9863 5.73633L19.377 6.28613C18.8642 6.46123 18.4612 6.86421 18.2861 7.37695L17.7363 8.98633C17.6593 9.2119 17.3407 9.2119 17.2637 8.98633L16.7139 7.37695C16.5388 6.86421 16.1358 6.46123 15.623 6.28613L14.0137 5.73633C13.7881 5.65927 13.7881 5.34073 14.0137 5.26367L15.623 4.71387C16.1358 4.53877 16.5388 4.13579 16.7139 3.62305L17.2637 2.01367Z",
    stroke: "#8351CD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 10V15.5C21 16.0304 20.7893 16.5391 20.4142 16.9142C20.0391 17.2893 19.5304 17.5 19 17.5H10.3613C9.49622 17.5 8.67324 17.8734 8.10357 18.5245L5.5 21.5V18.3559C5.5 17.8545 5.15483 17.4191 4.66667 17.3047V17.3047C3.69035 17.076 3 16.2052 3 15.2024V5.5C3 4.96957 3.21071 4.46086 3.58579 4.08579C3.96086 3.71071 4.46957 3.5 5 3.5H10.5",
    stroke: "#8351CD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1234_17850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAiChatColored);
export default __webpack_public_path__ + "static/media/icon_ai_chat_colored.4a9c3f38e561fd368c5ed6a1d106608a.svg";
export { ForwardRef as ReactComponent };